import { auth } from '../../firebase';
import { TALENT_API_BASE } from '../TalentSearch/talentAccount';

const BASE = `${TALENT_API_BASE}/v2/agent`;

async function request(path, options = {}) {
  if (!auth.currentUser) throw new Error('Please sign in again.');
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(`${BASE}${path}`, {
    ...options,
    headers: { ...options.headers, Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(typeof body.detail === 'string' ? body.detail : 'Research could not complete. Please try again.');
  }
  return response;
}

export async function loadRun(id, signal) {
  return (await request(`/runs/${id}`, { signal })).json();
}

export async function readDocument(file, signal) {
  if (file.size > 5 * 1024 * 1024) throw new Error('Attach a file smaller than 5 MB.');
  const response = await request(`/document?filename=${encodeURIComponent(file.name)}`, {
    method: 'POST', body: file, signal, headers: { 'Content-Type': 'application/octet-stream' },
  });
  return response.json();
}

// Stream real tool progress. Splitting may occur inside a line or an Arabic
// character, so retain both the decoder's state and the unfinished JSON line.
export async function runAgent(body, signal, onEvent) {
  const response = await request('/turn', {
    method: 'POST', signal, body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' },
  });
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let pending = '';
  let finished = false;
  const consume = (line) => {
    if (!line.trim()) return;
    const event = JSON.parse(line);
    if (event.type === 'state' && event.state.status !== 'running') finished = true;
    onEvent(event);
  };
  try {
    while (true) {
      const { value, done } = await reader.read();
      pending += decoder.decode(value, { stream: !done });
      const lines = pending.split('\n');
      pending = lines.pop();
      lines.forEach(consume);
      if (done) break;
    }
    consume(pending);
    if (!finished) throw new Error('The connection was interrupted. Reopen this research to check its progress.');
  } finally {
    reader.releaseLock();
  }
}

// Browsing saved research never starts a search or calls a data provider.
export async function listRuns(before, signal) {
  return (await request(`/runs${before ? `?before=${encodeURIComponent(before)}` : ''}`, { signal })).json();
}
